function formatCardExpiry(expMonth: number, expYear: number): string {
    return `${expMonth.toString().padStart(2, "0")}/${expYear
        .toString()
        .substring(2, 4)}`;
}

export default formatCardExpiry;
